import { Injectable } from '@angular/core';

import { AlertService } from '@sailpoint-priv/armada-angular/src/sailpoint/angular/components/alert';
import { AlertConfig } from '@sailpoint-priv/armada-angular/src/sailpoint/angular/components/alert/alert.model';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {
  public alertConfig: AlertConfig = {
    align: 'top',
    duration: 3000
  };

  constructor(
    private alertService: AlertService
  ) {
  }

  public successMessage(message: string): void {
    this.alertConfig.icon = 'complete';
    this.alertConfig.color = 's2l';
    this.alertConfig.title = {
      translateKey: 'NOTIFICATIONS.TITLES.SUCCESS'
    };
    this.alertConfig.message = {
      translateKey: message
    };

    this.alertService.open(this.alertConfig).then();
  }

  public errorMessage(message: string): void {
    this.alertConfig.icon = 'error';
    this.alertConfig.color = 's4l';
    this.alertConfig.title = {
      translateKey: 'NOTIFICATIONS.TITLES.ERROR'
    };
    this.alertConfig.message = {
      translateKey: message
    };

    this.alertService.open(this.alertConfig).then();
  }

  /**
   * Show a message that is already display text, not a translation key.
   *
   * errorMessage sends whatever it is given to the translation pipe, so a
   * server-supplied sentence is looked up as a key, logged as missing, and could
   * collide with a real key or be read as interpolation syntax.
   */
  public errorMessageUntranslated(message: string): void {
    this.alertConfig.icon = 'error';
    this.alertConfig.color = 's4l';
    this.alertConfig.title = {
      translateKey: 'NOTIFICATIONS.TITLES.ERROR'
    };
    this.alertConfig.message = {
      untranslated: message
    };

    this.alertService.open(this.alertConfig).then();
  }

  public dismiss(): void {
    this.alertService.destroy();
  }
}
